(() => {
  const COOKIE_NAME = "student_mode";
  const ATTR_KEY = "student_mode";

  function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load cart.js");
    return await res.json();
  }

  async function setCartAttribute(value) {
    const body = { attributes: { [ATTR_KEY]: String(value) } };
    const res = await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error("Failed to POST /cart/update.js");
    return await res.json();
  }

  async function sync() {
    const cookieVal = getCookie(COOKIE_NAME) === "1" ? "1" : "0";

    try {
      const cart = await getCart();
      const current =
        cart.attributes && cart.attributes[ATTR_KEY] != null
          ? String(cart.attributes[ATTR_KEY])
          : null;

      if (current !== cookieVal) {
        await setCartAttribute(cookieVal);
      }
    } catch (e) {
      // Silent fail: don’t break storefront if cart calls fail
      console.warn("[student-mode] sync failed:", e);
    }
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", sync);

  // Helpful for Dawn AJAX flows / returning to tab
  window.addEventListener("focus", sync);

  // Keep this too (won’t hurt if it doesn’t fire)
  document.addEventListener("cart:refresh", sync);
})();
